<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          outlined
          small
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{ btnTitle }}
        </v-btn>
      </template>
      <v-card v-if="selectedToSeeDetail">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>خلاصه اشتراک</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              Save
            </v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <v-row class="my-1 mx-1">
      <v-col cols="6" sm="4">
        <label>عنوان:</label>
        <strong>{{ selectedToSeeDetail.title }}</strong>
      </v-col>

      <v-col cols="6" sm="4">
        <label>مدت اشتراک:</label>
        <strong>{{ selectedToSeeDetail.durationInMonth }} ماه</strong>
      </v-col>

      <v-col cols="6" sm="4">
        <label>وضعیت:</label>
        <strong>{{ selectedToSeeDetail.disabled ? 'غیرفعال' : 'فعال' }}</strong>
      </v-col>
      <v-col cols="6" sm="4" v-if="selectedToSeeDetail.totalPrice">
        <label>قیمت:</label>
        <strong
          >{{ selectedToSeeDetail.totalPrice.amount | priceSplitter
          }}{{ selectedToSeeDetail.totalPrice.currency }}</strong
        >
      </v-col>
      <v-col cols="12" sm="6">
        <label>تاریخ:</label>
        <strong>
          از {{ selectedToSeeDetail.startDateUtc | moment }} تا
          {{ selectedToSeeDetail.endDateUtc | moment }}</strong
        >
      </v-col>
      <v-col cols="12" v-if="selectedToSeeDetail.description">
        <label> توضیحات:</label>
        <strong>{{ selectedToSeeDetail.description }}</strong>
      </v-col>
    </v-row>
    <div
      class="w-100 d-flex justify-content-center mt-3"
      v-if="selectedToSeeDetail.items.length"
    >
      <v-sheet outlined>
        <v-data-table
          disable-pagination
          hide-default-footer
          :items="selectedToSeeDetail.items"
          :headers="itemsHeader"
        >
          <template v-slot:[`item.serviceType`]="{ item }">
            <v-chip small>{{ serviceTypeDisplayName(item.serviceType) }}</v-chip>
          </template>
          <template v-slot:[`item.price`]="{ item }">
            {{ item.price | priceSplitter }} ریال
          </template>
          <template v-slot:[`item.description`]="{ item }">
            {{
              item.description.length > 30
                ? item.description.slice(0, 30) + '...'
                : item.description
            }}
          </template>
        </v-data-table>
      </v-sheet>
    </div>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { GET_ENUMS } from '../../../enums/store/types';
import { RepoFactory } from '@/baseRepository/Factory';
const subscriptionRepository = () => RepoFactory.get('subscription');
import Helper from '@/core/helpers';
export default {
  mixins: [reusableMethodsMixin],
  props: {
    MerchantId: {
      type: String,
      default: "",
    },
    btnTitle: {
      type: String,
      default: "مشاهده جزئیات",
    },
  },
  data() {
    return {
      dialog:false,
      serviceTypeList: [],
      selectedToSeeDetail: null,
      itemsHeader: [
        { text: 'عنوان', value: 'title' },
        { text: 'نوع خدمت', value: 'serviceType' },
        { text: 'تعداد', value: 'amount' },
        { text: 'تعداد استفاده شده', value: 'usedAmount' },
        { text: 'ارزش استفاده شده', value: 'usedTotalPrice' },
        { text: 'تعداد باقی مانده', value: 'availableAmount' },
        { text: 'ارزش باقی مانده', value: 'availableTotalPrice' },
        { text: 'قیمت', value: 'price' },
        { text: 'توضیحات', value: 'description' },
      ],
    };
  },
  async mounted() {
    if (!this.$store.getters.allEnums.length) {
      await this.$store.dispatch(GET_ENUMS);
    }
    this.serviceType();
  },
  computed: {
    subscriptionBaseUrl() {
      return this.$store.getters.subscriptionBaseUrl;
    },
  },
  watch: {
    dialog(after, before) {
      
      if (this.MerchantId && after) {
        this.getCurrentActiveSubscription();
      }
    },
  },
  methods: {
    getCurrentActiveSubscription() {
      const loader = this.$loading.show();
      subscriptionRepository()
        .getActiveSubscriptionPlans(
          this.subscriptionBaseUrl,
          { MerchantId: this.MerchantId }
        )
        .then((res) => {
          this.selectedToSeeDetail = res.data;
          loader.hide();
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
          loader.hide();
        });
    },
    serviceTypeDisplayName(title) {
      if (this.serviceTypeList.length) {
        let result = this.serviceTypeList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    serviceType() {
      this.serviceTypeList = this.getEnumByTitle('ServiceType');
    },
  },
};
</script>

<style></style>
